import styled from 'styled-components';
// import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	overflow: hidden;
`;

interface BoxInfoProps {
	$colorText: string;
	$fontWeight: string;
	$pTop: number;
	$pBottom: number;
	$pLeft: number;
	$pRight: number;
	$mTop: number;
	$mBottom: number;
	$mLeft: number;
	$mRight: number;
}

export const boxInfo = styled.div<BoxInfoProps>`
	width: 100%;
	display: grid;
	grid-template-columns: auto auto;
	overflow: hidden;
	padding-top: ${(props) => props.$pTop}px;
	padding-left: ${(props) => props.$pLeft}px;
	padding-bottom: ${(props) => props.$pBottom}px;
	padding-right: ${(props) => props.$pRight}px;
	margin-top: ${(props) => props.$mTop}px;
	margin-left: ${(props) => props.$mLeft}px;
	margin-bottom: ${(props) => props.$mBottom}px;
	margin-right: ${(props) => props.$mRight}px;

	> p {
		font-weight: ${(props) => props.$fontWeight};
		font-family: 'nunito-regular';
		font-size: 1.3rem;
		color: ${(props) => props.$colorText};
	}
`;

export const textOrIcon = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-end;

	> p {
		font-size: 1rem;
		text-transform: uppercase;
	}

	> svg {
		font-size: 1rem;
	}
`;
